import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  gap: 1rem;
`;

export default Container;
